import React from "react";
// 3rd utils
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  listAll,
} from "firebase/storage";
// mui
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Modal from "@mui/material/Modal";
import { useStore } from "outstated";
import { AppStore } from "pages/_app";
import insertFirebaseUploader from "components/listings/Uploader/utils/insertFirebaseUploader";
import { useTheme } from "@mui/styles";
import { useRouter } from "next/router";

import deleteFromUploadLog from "lib/deleteFromUploadLog";
import firebaseDownloadFile from "components/Loans/LoanStepper/components/lib/firebaseDownloadFile";
import firebaseDeleteFile from "components/Loans/LoanStepper/components/lib/firebaseDeleteFile";
import pushToUploadLog from "lib/pustToUploadLog";
import calculateAndSetPercentCompleted from "components/Loans/LoanContainer/utils/calculateAndSetPercentCompleted";
import docLogStatusColor from "components/Loans/LoanContainer/utils/docLogStatusColor";
import { borderRadius } from "components/listings/DnDComponents/constants";
import updateLoanUploadLog from "components/listings/Uploader/utils/updateLoanUploadLog";
import updateLoan2 from "lib/updateLoan2";

import updateAdminLoan from "lib/Admin/updateAdminLoan";
import updateLoanSectionController2 from "components/Loans/LoanStepper/components/lib/updateLoanSectionController2";
import downloadEntityFiles from "components/Loans/LoanStepper/components/lib/downloadEntityFiles";
import updateLoanSectionController from "components/Loans/LoanStepper/components/lib/updateLoanSectionController";

function DocLogActions({
  key,
  setAnchorEl,
  loan,
  anchorEl,
  entry,
  showLogPreview,
  setShowLogPreview,
  logPreviewURL,
  setLogPreviewURL,
  setUserLoans,
  showRenameFile,
  setShowRenameFile,
}) {
  const theme = useTheme();
  const router = useRouter();

  const {
    user,
    userProfile,
    adminTableRows,
    setAdminTableRows,
    adminLoans,
    userPermissions,
    userRoles,
    setSnackbarData,
    showAdminChat,
    setShowAdminChat,
    firebaseStorage,
    loanSectionController,
    setLoanSectionController,
    showUploadLogSection,
    setShowUploadLogSection,
    showProcessing,
    setShowProcessing,
  } = useStore(AppStore);

  return (
    <Box
      key={key}
      sx={{
        textAlign: "right",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          margin: theme.spacing(0, 1),
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton
          sx={{ display: "flex", alignItems: "center" }}
          color="primary"
          onClick={(event) => {
            setAnchorEl({
              ...anchorEl,
              [entry.id]: event.currentTarget,
            });
          }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl[entry.id]}
          open={Boolean(anchorEl[entry.id])}
          transitionDuration={0} // speed up the open and close animation
          onClose={() => {
            setAnchorEl({
              ...anchorEl,
              [entry.id]: null,
            });
          }}
        >
          <MenuItem
            onClick={async () => {
              if (loan && insertFirebaseUploader(loan)) {
                const file = entry;
                const path = `client_files/${loan.UID}/loans/${loan.LoanIDCypher}/${file.sectionID}/`;
                const storageRef = ref(firebaseStorage, path + `${file.name}`);
                await firebaseDownloadFile(storageRef);
              } else {
                await downloadEntityFiles(entry);
              }
              setAnchorEl({
                ...anchorEl,
                [entry.id]: null,
              });
            }}
          >
            Download
          </MenuItem>
          <MenuItem
            onClick={async () => {
              // Close menu immediately
              setAnchorEl({
                ...anchorEl,
                [entry.id]: null,
              });

              // Then perform the async operations
              const uploadLog = loan.UploadLog;
              const [logEntry] = uploadLog.filter(
                (logEntry) => logEntry.id === entry.id
              );
              logEntry.status =
                logEntry.status === "unread" ? "read" : "unread";
              let updatedLoan = await updateLoanUploadLog(
                user,
                logEntry,
                loan,
                false
              );
              updatedLoan = Object.assign({}, updatedLoan);
              setUserLoans([updatedLoan]);
              const updatedAdminTableRows = adminTableRows.slice();
              const [toUpdateRow] = updatedAdminTableRows.filter(
                (row) => row.loanID === updatedLoan.id.toString()
              );
              const unreadCount = updatedLoan?.UploadLog?.filter(
                (entry) => entry.status === "unread"
              ).length;
              toUpdateRow.uploadLogUnread = unreadCount;
              setAdminTableRows(updatedAdminTableRows);
              const [targetAdminLoan] = adminLoans.filter(
                (adminLoan) => adminLoan.LoanID === updatedLoan.id.toString()
              );
              const updatedAdminLoanData = Object.assign(
                {},
                { ...targetAdminLoan.AdminLoanData }
              );
              if (updatedAdminLoanData?.uploadLogUnread?.unreadCount) {
                updatedAdminLoanData.uploadLogUnread.unreadCount = unreadCount;
              }
              await updateAdminLoan(
                user,
                targetAdminLoan,
                updatedAdminLoanData,
                "AdminLoanData"
              );
            }}
          >
            {entry.status === "unread" ? "Mark read" : "Mark unread"}
          </MenuItem>
          <MenuItem
            sx={{
              color: theme.palette.error.light,
              "&:hover": {
                color: theme.palette.error.main,
              },
            }}
            onClick={async () => {
              const uploadLog = loan.UploadLog;
              const [logEntry] = uploadLog.filter(
                (logEntry) => logEntry.id === entry.id
              );

              logEntry.status = `rejected_${userPermissions.Organization}`;
              let updatedLoan = await updateLoanUploadLog(
                user,
                logEntry,
                loan,
                false
              );
              updatedLoan = Object.assign({}, updatedLoan);
              setUserLoans([updatedLoan]);
              const updatedAdminTableRows = adminTableRows.slice();
              const [toUpdateRow] = updatedAdminTableRows.filter(
                (row) => row.loanID === updatedLoan.id.toString()
              );
              const uLoanSectionController = Object.assign(
                {},
                loanSectionController
              );
              uLoanSectionController[entry.sectionID].priority = "feedback";
              if (insertFirebaseUploader(loan)) {
                updateLoanSectionController2(
                  loan,
                  setLoanSectionController,
                  uLoanSectionController,
                  user,
                  entry.sectionID
                );
              } else {
                await updateLoanSectionController(
                  user,
                  uLoanSectionController,
                  loan
                );
                setLoanSectionController(uLoanSectionController);
              }
              const unreadCount = updatedLoan?.UploadLog?.filter(
                (entry) => entry.status === "unread"
              ).length;
              toUpdateRow.uploadLogUnread = unreadCount;
              setAdminTableRows(updatedAdminTableRows);
              const [targetAdminLoan] = adminLoans.filter(
                (adminLoan) => adminLoan.LoanID === updatedLoan.id.toString()
              );
              const updatedAdminLoanData = Object.assign(
                {},
                { ...targetAdminLoan.AdminLoanData }
              );
              if (updatedAdminLoanData?.uploadLogUnread?.unreadCount) {
                updatedAdminLoanData.uploadLogUnread.unreadCount = unreadCount;
              }
              await updateAdminLoan(
                user,
                targetAdminLoan,
                updatedAdminLoanData,
                "AdminLoanData"
              );
              setAnchorEl({
                ...anchorEl,
                [entry.id]: null,
              });
            }}
          >
            Reject
          </MenuItem>
          <MenuItem
            sx={{
              color: theme.palette.success.light,
              "&:hover": {
                color: theme.palette.success.main,
              },
            }}
            onClick={async () => {
              // Close menu immediately
              setAnchorEl({
                ...anchorEl,
                [entry.id]: null,
              });

              // Then perform the async operations
              const uploadLog = loan.UploadLog;
              const [logEntry] = uploadLog.filter(
                (logEntry) => logEntry.id === entry.id
              );
              logEntry.status = `approved_${userPermissions.Organization}`;
              let updatedLoan = await updateLoanUploadLog(
                user,
                logEntry,
                loan,
                false
              );
              updatedLoan = Object.assign({}, updatedLoan);
              setUserLoans([updatedLoan]);
              const updatedAdminTableRows = adminTableRows.slice();
              const [toUpdateRow] = updatedAdminTableRows.filter(
                (row) => row.loanID === updatedLoan.id.toString()
              );
              const unreadCount = updatedLoan?.UploadLog?.filter(
                (entry) => entry.status === "unread"
              ).length;
              toUpdateRow.uploadLogUnread = unreadCount;
              setAdminTableRows(updatedAdminTableRows);
              const [targetAdminLoan] = adminLoans.filter(
                (adminLoan) => adminLoan.LoanID === updatedLoan.id.toString()
              );
              const updatedAdminLoanData = Object.assign(
                {},
                { ...targetAdminLoan.AdminLoanData }
              );
              if (updatedAdminLoanData?.uploadLogUnread?.unreadCount) {
                updatedAdminLoanData.uploadLogUnread.unreadCount = unreadCount;
              }
              await updateAdminLoan(
                user,
                targetAdminLoan,
                updatedAdminLoanData,
                "AdminLoanData"
              );
            }}
          >
            Approve
          </MenuItem>
          <MenuItem
            onClick={() => {
              const updatedShowRenameFile = Object.assign({}, showRenameFile);
              updatedShowRenameFile[entry.id] = !showRenameFile[entry.id];
              setShowRenameFile(updatedShowRenameFile);
              setAnchorEl({
                ...anchorEl,
                [entry.id]: null,
              });
            }}
          >
            Rename
          </MenuItem>
          <MenuItem
            onClick={async () => {
              // Close menu immediately
              setAnchorEl({
                ...anchorEl,
                [entry.id]: null,
              });

              // Then perform the async operations
              const storageRef = ref(
                firebaseStorage,
                `client_files/${loan.UID}/loans/${loan.LoanIDCypher}/${entry.sectionID}/${entry.name}`
              );

              await firebaseDeleteFile(storageRef);

              const uploadLog = loan.UploadLog;
              const [logEntry] = uploadLog.filter(
                (logEntry) => logEntry.id === entry.id
              );
              logEntry.status = `Deleting...`;
              let updatedLoan = await updateLoanUploadLog(
                user,
                logEntry,
                loan,
                false
              );
              updatedLoan = Object.assign({}, updatedLoan);
              setUserLoans([updatedLoan]);

              const updatedAdminTableRows = adminTableRows.slice();
              const [toUpdateRow] = updatedAdminTableRows.filter(
                (row) => row.loanID === updatedLoan.id.toString()
              );
              const unreadCount = updatedLoan?.UploadLog?.filter(
                (entry) => entry.status === "unread"
              ).length;
              toUpdateRow.uploadLogUnread = unreadCount;
              setAdminTableRows(updatedAdminTableRows);
              const [targetAdminLoan] = adminLoans.filter(
                (adminLoan) => adminLoan.LoanID === updatedLoan.id.toString()
              );
              const updatedAdminLoanData = Object.assign(
                {},
                { ...targetAdminLoan.AdminLoanData }
              );
              if (updatedAdminLoanData?.uploadLogUnread?.unreadCount) {
                updatedAdminLoanData.uploadLogUnread.unreadCount = unreadCount;
              }
              await updateAdminLoan(
                user,
                targetAdminLoan,
                updatedAdminLoanData,
                "AdminLoanData"
              );
            }}
          >
            Delete
          </MenuItem>

          <MenuItem
            onClick={async () => {
              const storageRef = ref(
                firebaseStorage,
                `client_files/${loan.UID}/loans/${loan.LoanIDCypher}/${entry.sectionID}/${entry.name}`
              );
              const resp = await getDownloadURL(storageRef);
              setLogPreviewURL(resp);
              setShowLogPreview(true);
              setAnchorEl({
                ...anchorEl,
                [entry.id]: null,
              });
            }}
          >
            Preview
          </MenuItem>

          <MenuItem
            onClick={async () => {
              const storageRef = ref(
                firebaseStorage,
                `client_files/${loan.UID}/loans/${loan.LoanIDCypher}/${entry.sectionID}/${entry.name}`
              );

              const resp = await getDownloadURL(storageRef);

              window.open(resp, "_blank");
            }}
          >
            Preview in new tab
          </MenuItem>
        </Menu>
      </Box>
      <Modal
        open={showLogPreview}
        onClose={() => {
          setShowLogPreview(false);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "95%",
            height: "95%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <iframe
            style={{
              height: "100%",
              width: "100%",
            }}
            src={logPreviewURL}
          >
            Loading…
          </iframe>
        </Box>
      </Modal>
    </Box>
  );
}

export default DocLogActions;
